"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeTopBarNotificationsEvent = exports.ChangeTopBarVisibilityEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class ChangeTopBarVisibilityEvent extends web_ui_framework_1.Event {
}
exports.ChangeTopBarVisibilityEvent = ChangeTopBarVisibilityEvent;
class ChangeTopBarNotificationsEvent extends web_ui_framework_1.Event {
}
exports.ChangeTopBarNotificationsEvent = ChangeTopBarNotificationsEvent;
//# sourceMappingURL=topBarEvents.js.map